


import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CartState } from "../dataLayer/ProductsModels/Entities/product.state";
import { AppState } from "./constants/app.models";


export const GENERAL = createFeatureSelector<AppState>('General');
export const Cart = createFeatureSelector<CartState>('cart');




export const loader_selector = createSelector(
  GENERAL, (general_state)=> {
    return general_state.loader;
  }
);


export const CATEGORIES_SELECTOR = createSelector(
  GENERAL, (general_state)=> {
    return general_state.categories;
  }
);


export const paymob_iframe_selector = createSelector(
  GENERAL, (general_state)=> {
    return general_state.paymob_iframe;
  }
);


export const CART_DISPLAY_STATUS_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.cart_display_status;
  }
);

export const CART_TOTAL_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.cart_total;
  }
);


export const CART_LIST_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.cart_list;
  }
);


export const USER_SELECTOR = createSelector(
  GENERAL, cartState => {
      return cartState.user;
  }
);

export const HEADER_CART_SELECTOR = createSelector(
  GENERAL, cartState => {
      return cartState.show_header_cart;
  }
);


export const HEADER_AUTH_MODAL_SELECTOR = createSelector(
  GENERAL, cartState => {
      return cartState.show_auth_modal;
  }
);

export const ADD_ADDRESS_MODAL_DISPLAY_STATUS_SELECTOR = createSelector(
  GENERAL, cartState => {
      return cartState.show_add_address_modal;
  }
);

export const ACTIVE_LOCATION_SELECTOR = createSelector(
  GENERAL, cartState => {
      return cartState.active_location;
  }
);


export const voucher_selector = createSelector(
  Cart, cartState => {
      return cartState.voucher_code;
  }
);


export const voucher_data_selector = createSelector(
  Cart, cartState => {
      return cartState.voucher_data;
  }
);

export const set_voucher_percentage_selector = createSelector(
  Cart, cartState => {
      return cartState.voucher_percentage;
  }
);


export const set_cart_total_with_voucher_selector = createSelector(
  Cart, cartState => {
      return cartState.cart_total_with_voucher;
  }
);


export const CHECKOUT_NOTE_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.checkout_notes;
  }
);



export const ACTIVE_USER_ADDRESS_SELECTOR = createSelector(
  GENERAL, state => {
      return state.active_user_address;
  }
);


export const USER_ADDRESSES_SELECTOR = createSelector(
  GENERAL, state => {
      return state.user_addresses!;
  }
);



export const ORDER_TAX_DELIEVERY_SELECTOR = createSelector(
  GENERAL, state => {
      return state.active_order_tax_delievery;
  }
);


export const REDIRECT_SELECTOR = createSelector(
  GENERAL, state => {
      return state.redirect;
  }
);


export const Wallet_Display_Status_SELECTOR = createSelector(
  GENERAL, state => {
      return state.user_wallets?.wallet_display_status;
  }
);


export const USER_WALLETS_SELECTOR = createSelector(
  GENERAL, state => {
      return state.user_wallets?.wallets;
  }
);

export const USER_CREDIT_SELECTOR = createSelector(
  GENERAL, state => {
      return state.user_credit;
  }
);

export const HOME_BRAND_ID_SELECTOR = createSelector(
  GENERAL, state => {
      return state.home_brand_id;
  }
);


export const site_attribute_selector = createSelector(
  GENERAL, state => {
      return state.website_attribute;
  }
);


export const delivery_type_selector = createSelector(
  GENERAL, state => {
    return state.delivery_type;
  }
);


export const SlidersSelector = createSelector(
  GENERAL, state => {
      return state.home.sliders;
  }
);

export const FirstSectionSlidersSelector = createSelector(
  GENERAL, state => {
      return state.home.sliders?.adsSpacesPositions!![0].AdsSpacesprice
  }
);

export const SecondSectionSlidersSelector = createSelector(
  GENERAL, state => {
      console.log(state.home.sliders)

      return state.home.sliders?.adsSpacesPositions!![1].AdsSpacesprice
  }
);

export const ThiredSectionSlidersSelector = createSelector(
  GENERAL, state => {
      console.log(state.home.sliders)

      return state.home.sliders?.adsSpacesPositions!![2].AdsSpacesprice  || []
  }
);


export const SubCatSelector = createSelector(
  GENERAL, state => {

      if ( !state ) return {};
      return state.home.SubCategories;
  }
);


export const HotDealsSelector = createSelector(
  GENERAL, state => {
      return state.home.specialSections;
  }
);


export const CategoriesSelector = createSelector(
  GENERAL, state => {
      return state.home.Categories;
  }
);


export const BrandsSelector = createSelector(
  GENERAL, state => {
      return state.home.brands;
  }
);
